import { render, staticRenderFns } from "./ExampleInfinitePaginationTable.vue?vue&type=template&id=41cab454&scoped=true"
import script from "./ExampleInfinitePaginationTable.vue?vue&type=script&lang=js"
export * from "./ExampleInfinitePaginationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41cab454",
  null
  
)

export default component.exports